export default {
  name: 'CTitle',
  components: {},
  props: {
    title: {
      default: '',
      type: String
    },
    info: {
      default: () => ({}),
      type: Object
    },
    noline: {
      default: false,
      type: Boolean
    },
    stitle: {
      default: () => ({}),
      type: Object
    },
    sdesc: {
      default: () => ({}),
      type: Object
    },
    sline: {
      default: () => ({}),
      type: Object
    }
  }
};